import { useContext, useEffect, useState } from 'react';
import { BsPencil } from 'react-icons/bs';
import { putIntroduction } from '../../../apis/profile.api';
import {
  handleCheckChangeForm,
  handleCheckFalsyForm,
} from '../../../common/checkForm';
import {
  handleDeleteForm,
  handleResetForm,
  handleSubmitForm,
} from '../../../common/formCallApi';
import { IModalProps as IProps } from '../../../interfaces/components/modal.interface';
import { IUserIntroduction } from '../../../interfaces/profile.interface';
import FormLayout from '../../../layouts/FormLayout/FormLayout2';
import AuthContext from '../../../state/auth/AuthContext';
import { useModal } from '../../../state/modal-provider/ModalProvider';
import { initIntroductionState } from '../../../state/user-setting-modal/initState';
import PrimaryTextArea from '../../input/PrimaryTextArea';

const UserIntroductionModal = ({
  defaultData,
  cancelCallback,
  isModalCancelled,
}: IProps) => {
  const [userIntroduction, setUserIntroduction] = useState<IUserIntroduction>({
    bio: defaultData ?? '',
  });
  const [isSubmit, setIsSubmit] = useState<boolean>(false);
  const { setLoading } = useContext(AuthContext);
  const { toast } = useModal();

  const handleSetState = (name: string, value: string) => {
    setUserIntroduction((state) => ({ ...state, [name]: value }));
  };

  const resetForm = () =>
    handleResetForm({
      setValueState: setUserIntroduction,
      initValueState: initIntroductionState,
    });

  const submitForm = () =>
    handleSubmitForm({
      callback: () => setIsSubmit(true),
      data: userIntroduction,
      asyncFunc: putIntroduction,
      id: defaultData?._id ?? '',
      formCancelCallBack: cancelCallback,
      toggleSuccessModalNoti: () =>
        toast.success({
          content: 'Cập nhật thông tin thành công.',
        }),
      toggleErrorModalNoti: () =>
        toast.error({
          content: 'Có lỗi xảy ra, vui lòng thử lại.',
        }),
      setLoading,
    });

  const deleteForm = () =>
    handleDeleteForm({
      runAsyncFunc: !handleCheckFalsyForm({ bio: defaultData ?? '' }),
      callback: () => setIsSubmit(false),
      asyncFunc: putIntroduction,
      id: initIntroductionState,
      handleResetForm: resetForm,
      formCancelCallBack: cancelCallback,
      toggleSuccessModalNoti: () =>
        toast.success({
          content: 'Xoá thông tin thành công.',
        }),
      toggleErrorModalNoti: () =>
        toast.error({
          content: 'Có lỗi xảy ra, vui lòng thử lại.',
        }),
      setLoading,
    });

  const handleToggleLeaveModal = () => {
    if (!handleCheckChangeForm(userIntroduction, { bio: defaultData ?? '' })) {
      toast.warning({
        deleteTitle: 'Thoát',
        cancelTitle: 'Ở lại',
        onDelete: () => cancelCallback && cancelCallback(false),
        title: 'Thay đổi chưa lưu',
        content:
          'Thay đổi của bạn chưa được lưu. Bạn vẫn muốn thoát mà không lưu?',
      });
    } else {
      cancelCallback && cancelCallback(false);
    }
  };

  // warning when leave modal
  useEffect(() => {
    if (isModalCancelled) {
      handleToggleLeaveModal();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalCancelled]);

  return (
    <FormLayout
      classname="relative"
      formName="Giới thiệu"
      deleteCallback={() =>
        toast.warning({
          title: 'Xoá mục kinh nghiệm!',
          content: 'Bạn chắc chắn muốn xoá nội dung mục kinh nghiệm?',
          deleteTitle: 'Xoá',
          cancelTitle: 'Huỷ',
          onDelete: deleteForm,
        })
      }
      saveCallback={submitForm}
      cancelCallback={handleToggleLeaveModal}
      disabledDeletButton={handleCheckFalsyForm(userIntroduction)}
    >
      <PrimaryTextArea
        icon={<BsPencil />}
        desc=""
        value={userIntroduction.bio}
        error={isSubmit && !userIntroduction}
        setValue={handleSetState}
        inputName="bio"
        isObject
      />
      {isSubmit && !userIntroduction && (
        <p className="text-red-500">Đây là trường bắt buộc!</p>
      )}
    </FormLayout>
  );
};

export default UserIntroductionModal;
